import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SupplierInvoice from "services/Setup/Supplier/SupplierInvoiceService";
import { notification } from "antd";
import { rest } from "lodash";

export const initialState = {
  loading: false,
  loadingApproval: false,
  message: "",
  showMessage: false,
  redirect: "",
  supplierInvoiceList: [],
  poSupplierInvoiceList: [],
  response: [],
  subSupplierList: [],
  statusResponse: [],
  supplierInvoiceSoftCopyList: [],
  supplierInvoiceDocSoftCopyValidateList: [],
  detailInvoiceView: [],
  getCount: 0,
};

export const getSearchListSupplierSlice = createAsyncThunk(
  "supplierInvoiceSlice/getSearchListSupplierSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SupplierInvoice.getSearchListSupplierService(data);
      if (response?.data) {
        return response.data;
      }
      return { data: [], count: 0 };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Gagal mengambil data invoice supplier",
      );
    }
  },
);

export const getSupplierInvoiceSearchInvoiceSlice = createAsyncThunk(
  "supplierInvoiceSlice/getSupplierInvoiceSearchInvoiceSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SupplierInvoice.getSupplierInvoiceSearchInvoiceService(data);
      if (response?.data) {
        return response.data;
      }
      return { data: [], count: 0 };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Gagal mengambil data invoice supplier",
      );
    }
  },
);

export const getSupplierInvoiceSearchInvoiceApprovalSlice = createAsyncThunk(
  "supplierInvoiceSlice/getSupplierInvoiceSearchInvoiceApprovalSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SupplierInvoice.getSupplierInvoiceSearchInvoiceApprovalService(
          data,
        );
      if (response?.data) {
        return response.data;
      }
      return { data: [], count: 0 };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Gagal mengambil data invoice supplier",
      );
    }
  },
);

export const addInvoiceSupplierSlice = createAsyncThunk(
  "supplierInvoiceSlice/addInvoiceSupplierSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SupplierInvoice.addInvoiceSupplierServer(data);
      if (response?.status === 200 || response?.status === 201) {
        notification.success({
          message: "Success",
          description: "Invoice berhasil ditambahkan",
          duration: 3,
        });
        return response?.data || {};
      } else {
        notification.error({
          message: "Error",
          description: "Gagal menambahkan invoice",
          duration: 3,
        });
        return rejectWithValue("Failed to add invoice");
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message || "Gagal menambahkan invoice",
        duration: 3,
      });
      return rejectWithValue(error.message || "Failed to add invoice");
    }
  },
);

export const putInvoiceSupplierApprovalSlice = createAsyncThunk(
  "supplierInvoiceSlice/putInvoiceSupplierApprovalSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SupplierInvoice.putInvoiceSupplierApprovalServer(data);
      if (response?.status === 200 || response?.status === 204) {
        notification.success({
          message: "Success",
          description: "Invoice berhasil di-approve",
          duration: 3,
        });
        return response?.data || {};
      } else {
        notification.error({
          message: "Error",
          description: "Gagal meng-approve invoice",
          duration: 3,
        });
        return rejectWithValue("Failed to approve invoice");
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message || "Gagal meng-approve invoice",
        duration: 3,
      });
      return rejectWithValue(error.message || "Failed to approve invoice");
    }
  },
);

export const getSearchListInvoiceSupplierSoftCopySlice = createAsyncThunk(
  "supplierInvoiceSlice/getSearchListInvoiceSupplierSoftCopySlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SupplierInvoice.getSearchListInvoiceSupplierSoftCopyService(data);
      if (response?.data) {
        return response.data;
      }
      return { data: [], count: 0 };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Gagal mengambil data invoice supplier",
      );
    }
  },
);

export const getSearchListInvoiceSupplierDocSoftCopyValidateSlice =
  createAsyncThunk(
    "supplierInvoiceSlice/getSearchListInvoiceSupplierDocSoftCopyValidateSlice",
    async (data, { rejectWithValue }) => {
      try {
        const response =
          await SupplierInvoice.getSearchListInvoiceSupplierDocSoftCopyValidateService(
            data,
          );
        if (response?.data) {
          return response.data;
        }
        return { data: [], count: 0 };
      } catch (error) {
        return rejectWithValue(
          error?.response?.data?.message ||
            error?.message ||
            "Gagal mengambil data invoice supplier",
        );
      }
    },
  );

export const getSearchlistDetailInvoiceViewSlice = createAsyncThunk(
  "supplierInvoiceSlice/getSearchlistDetailInvoiceViewSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SupplierInvoice.getSearchlistDetailInvoiceViewService(data);
      if (response?.data) {
        return response.data;
      }
      return { data: [], count: 0 };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Gagal mengambil data invoice supplier",
      );
    }
  },
);

export const supplierInvoiceSlice = createSlice({
  name: "supplierInvoice",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    falseMessage: (state) => {
      state.message = "";
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    resetState: (state) => {
      state.loading = false;
      state.message = "";
      state.showMessage = false;
      state.redirect = "";
      state.supplierInvoiceList = [];
      state.poSupplierInvoiceList = [];
      state.response = [];
      state.subSupplierList = [];
      state.statusResponse = [];
      state.getCount = 0;
    },
  },
  extraReducers: (builder) => {
    // getSearchListSupplierSlice

    builder.addCase(getSearchListSupplierSlice.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSearchListSupplierSlice.fulfilled, (state, action) => {
      state.supplierInvoiceList = action.payload?.data || [];
      state.loading = false;
      state.getCount = action.payload?.count || 0;
    });
    builder.addCase(getSearchListSupplierSlice.rejected, (state, action) => {
      state.loading = false;
      state.message = action.payload || action.error.message;
      state.showMessage = true;
    });
    // getSupplierInvoiceSearchInvoiceSlice
    builder.addCase(getSupplierInvoiceSearchInvoiceSlice.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getSupplierInvoiceSearchInvoiceSlice.fulfilled,
      (state, action) => {
       

        state.poSupplierInvoiceList = action.payload?.data || [];
        state.loading = false;
        state.getCount = action.payload?.count || 0;
      },
    );
    builder.addCase(
      getSupplierInvoiceSearchInvoiceSlice.rejected,
      (state, action) => {
        state.loading = false;
        state.message = action.payload || action.error.message;
        state.showMessage = true;
      },
    );
    // addInvoiceSupplierSlice
    builder.addCase(addInvoiceSupplierSlice.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addInvoiceSupplierSlice.fulfilled, (state, action) => {
      state.response = action.payload || [];
      state.statusResponse = action.payload?.status || [];
      state.loading = false;
    });
    builder.addCase(addInvoiceSupplierSlice.rejected, (state, action) => {
      state.loading = false;
      state.message = action.payload || action.error.message;
      state.showMessage = true;
    });
    // getSupplierInvoiceSearchInvoiceApprovalSlice
    builder.addCase(
      getSupplierInvoiceSearchInvoiceApprovalSlice.pending,
      (state) => {
        state.loading = true;
      },
    );
    builder.addCase(
      getSupplierInvoiceSearchInvoiceApprovalSlice.fulfilled,
      (state, action) => {
        state.supplierInvoiceList = action.payload?.data || [];
        state.loading = false;
        state.getCount = action.payload?.count || 0;
      },
    );
    builder.addCase(
      getSupplierInvoiceSearchInvoiceApprovalSlice.rejected,
      (state, action) => {
        state.loading = false;
        state.message = action.payload || action.error.message;
        state.showMessage = true;
      },
    );
    // putInvoiceSupplierApprovalSlice
    builder.addCase(putInvoiceSupplierApprovalSlice.pending, (state) => {
      state.loadingApproval = true;
    });
    builder.addCase(
      putInvoiceSupplierApprovalSlice.fulfilled,
      (state, action) => {
        state.response = action.payload || [];
        state.loadingApproval = false;
      },
    );
    builder.addCase(
      putInvoiceSupplierApprovalSlice.rejected,
      (state, action) => {
        state.loadingApproval = false;
        state.message = action.payload || action.error.message;
        state.showMessage = true;
      },
    );

    // getSearchListInvoiceSupplierSoftCopySlice
    builder.addCase(
      getSearchListInvoiceSupplierSoftCopySlice.pending,
      (state) => {
        state.loading = true;
      },
    );
    builder.addCase(
      getSearchListInvoiceSupplierSoftCopySlice.fulfilled,
      (state, action) => {
        state.supplierInvoiceSoftCopyList = action.payload?.data || [];
        state.loading = false;
        state.getCount = action.payload?.count || 0;
      },
    );
    builder.addCase(
      getSearchListInvoiceSupplierSoftCopySlice.rejected,
      (state, action) => {
        state.loading = false;
        state.message = action.payload || action.error.message;
        state.showMessage = true;
      },
    );
    // getSearchListInvoiceSupplierDocSoftCopyValidateSlice
    builder.addCase(
      getSearchListInvoiceSupplierDocSoftCopyValidateSlice.pending,
      (state) => {
        state.loading = true;
      },
    );
    builder.addCase(
      getSearchListInvoiceSupplierDocSoftCopyValidateSlice.fulfilled,
      (state, action) => {
        state.supplierInvoiceDocSoftCopyValidateList =
          action.payload?.data || [];
        state.loading = false;
        state.getCount = action.payload?.count || 0;
      },
    );
    builder.addCase(
      getSearchListInvoiceSupplierDocSoftCopyValidateSlice.rejected,
      (state, action) => {
        state.loading = false;
        state.message = action.payload || action.error.message;
        state.showMessage = true;
      },
    );

    // getSearchlistDetailInvoiceViewSlice
    builder.addCase(getSearchlistDetailInvoiceViewSlice.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getSearchlistDetailInvoiceViewSlice.fulfilled,
      (state, action) => {
        state.detailInvoiceView = action.payload?.data || [];
        state.loading = false;
        state.getCount = action.payload?.count || 0;
      },
    );
    builder.addCase(
      getSearchlistDetailInvoiceViewSlice.rejected,
      (state, action) => {
        state.loading = false;
        state.message = action.payload || action.error.message;
        state.showMessage = true;
      },
    );
  },
});

export const {
  showNotification,
  showLoading,
  falseMessage,
  hideNotification,
  resetState,
} = supplierInvoiceSlice.actions;

export default supplierInvoiceSlice.reducer;
